import * as React from 'react';
import { Overlay } from '../components/Overlay';
import { ProgressBar } from '../components/ProgressBar';
import { isUrlBlob, loadFile } from '../utils';
import {
  getAvailableFilename,
  uploadFile,
  uploadFileCancellable
} from '../utils/S3Utils';
import RecordType from '../data/RecordType';
import FileType from '../data/FileType';
import { getStoreState } from '../state/Store';
import { addUserVideo } from '../utils/FirebaseUtils';
import { ManagedUpload } from 'aws-sdk/clients/s3';
import { reportBFError } from 'utils/Tracker';

interface Props {
  recordingUrl: string;
}

interface State {
  progress: number;
}

export class RecordingShareModal extends React.Component<Props, State> {
  videoUploadRequest: ManagedUpload | undefined = undefined;
  state: State = {
    progress: 0
  };

  componentDidMount() {
    const { recordingUrl } = this.props;
    if (!isUrlBlob(recordingUrl)) {
      this.setState({ progress: 1 });
      return;
    }
    this.uploadVideo();
  }

  uploadVideo = async () => {
    console.log('upload video file');
    const filename = await getAvailableFilename(RecordType.Video);
    const appState = getStoreState().app;
    await uploadFile(filename + '.jpg', appState.videoThumbnail!, FileType.jpg);
    const blob = await loadFile(this.props.recordingUrl);
    const file = new File([blob], 'video.mp4');
    const flyerState = getStoreState().flyer;
    let effectsCount = 0;
    flyerState.layers.forEach(layer => {
      effectsCount += layer.visibleEffectsCount;
    });
    const duration = flyerState.motionSource.getDuration();
    this.videoUploadRequest = uploadFileCancellable(
      filename + '.mp4',
      file,
      FileType.mp4,
      async () => {
        try {
          await addUserVideo(
            appState.user!.uid,
            'videos',
            filename,
            flyerState.layers.length,
            effectsCount,
            duration,
            blob.size / 1000
          );
          this.setState({ progress: 1 });
        } catch (e) {
          alert(e);
        }
      },
      (error: string) => {
        reportBFError(new Error(error));
        alert(error);
      },
      (progress: number) => {
        if (progress < 1) {
          this.setState({ progress });
        }
      }
    );
  };

  componentWillUnmount() {
    if (this.state.progress < 0) {
      if (this.videoUploadRequest) {
        this.videoUploadRequest.abort();
      }
    }
  }

  render() {
    const { progress } = this.state;
    if (progress < 1) {
      return (
        <Overlay title="Uploading">
          <ProgressBar level={progress} />
        </Overlay>
      );
    }
    return (
      <Overlay title="Your video is ready to share">
        <p>You can now view and share your video using your phone.</p>
        <div className="store-links">
          <a
            href="https://play.google.com/store/apps/details?id=com.nuthinking.beatflyer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Apple App Store"
              src="/media/Download_on_the_Play_Store.svg"
              draggable={false}
            />
          </a>
          <a
            href="https://apps.apple.com/app/beatflyer-animated-flyers/id6444857001"
            // href="https://itunes.apple.com/app/beatflyer-videos/id1374994539"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Apple App Store"
              src="/media/Download_on_the_App_Store.svg"
              draggable={false}
            />
          </a>
        </div>
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/video/RecordingShareModal.tsx